module.exports = __webpack_public_path__ + "static/1 (6)-d324a376daa02d56fe874a696303d361.jpg";